import { render } from "./VerticalSlider.vue?vue&type=template&id=4848969c&scoped=true"
import script from "./VerticalSlider.vue?vue&type=script&lang=js"
export * from "./VerticalSlider.vue?vue&type=script&lang=js"

import "./VerticalSlider.vue?vue&type=style&index=0&id=4848969c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4848969c"

export default script